import { Component } from '@angular/core';

@Component({
  selector: 'app-theft-notice-alert',
  templateUrl: './theft-notice-alert.component.html',
  styleUrls: ['./theft-notice-alert.component.scss'],
  standalone: false,
})
export class TheftNoticeAlertComponent {}
